/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { JofiStudentProfilePublic } from '../models/jofi-student-profile-public';

@Injectable({
  providedIn: 'root',
})
export class JofiAdminStudentProfilesPublicService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation studentProfilesPublicAdminControllerFindAllPaginated
   */
  static readonly StudentProfilesPublicAdminControllerFindAllPaginatedPath = '/v1/admin/student-profiles-public';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `studentProfilesPublicAdminControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  studentProfilesPublicAdminControllerFindAllPaginated$Response(params?: {
    sortBy?: any;
    search?: any;
    limit?: any;
    page?: any;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Array<JofiStudentProfilePublic>>> {

    const rb = new RequestBuilder(this.rootUrl, JofiAdminStudentProfilesPublicService.StudentProfilesPublicAdminControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('limit', params.limit, {});
      rb.query('page', params.page, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<JofiStudentProfilePublic>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `studentProfilesPublicAdminControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  studentProfilesPublicAdminControllerFindAllPaginated(params?: {
    sortBy?: any;
    search?: any;
    limit?: any;
    page?: any;
    context?: HttpContext
  }
): Observable<Array<JofiStudentProfilePublic>> {

    return this.studentProfilesPublicAdminControllerFindAllPaginated$Response(params).pipe(
      map((r: StrictHttpResponse<Array<JofiStudentProfilePublic>>) => r.body as Array<JofiStudentProfilePublic>)
    );
  }

}
